(function($, LF) {
  $(function() {
    $("form.product_form_compact").each(function(elem) {
      new QuickAddForms(this);
    });
    
    $("form.product_form").each(function(elem) {
      new QuickAddForms(this);
    });
    
    $(".add-basket").leanModal({event_name: 'modal'});
  });

  var QuickAddForms = function(aForm) {
    this.theForm = $(aForm);
  	$(this.theForm).submit($.proxy(this.onFormSubmit, this));

    Shopify.getCart(this.updateCheckout);
  }

  function _isNormalInteger(str) {
    var n = ~~Number(str);
    return String(n) === str && n >= 0;
  }

  QuickAddForms.prototype = {
  	onFormSubmit : function(event) {
          var frm = $(this.theForm);
  		var id = $(frm).find("input[name=id]").val();
  		var quantity = $(frm).find("[name=quantity]").val();
  	
  		if(_isNormalInteger(quantity) && quantity > 0) {
  			//$(frm).find("input[name=quantity]").val(1);
  			Shopify.addItem(id, quantity, $.proxy(this.onSubmitComplete, this));		            
  		}
        
  		event.preventDefault();
        	return false;
  	},
  	
  	onSubmitComplete : function(data) {
  		var frm = $(this.theForm);
        	var btn = frm.find("input:submit");
        	var q = frm.find("[name=quantity]").val();
        
          if(frm.hasClass("product_form_compact")) {
            frm.hide();
            frm.after('<p class="success product_form_compact">Added to Cart!</p>');
            
            Shopify.getCart($.proxy(this.updateCount, this));
          } else if(frm.closest("div.modal").length > 0){
            
            btn.notify("Added " + q + " to your basket!", {autoHideDelay:3000,className:"success",showDuration:200,gap:2});
            
            
            Shopify.getCart($.proxy(this.updateCount, this));
          } else {
            var modal = $(".add-basket").data("rel");
            $(modal).find("span.quantity").text(q);          
            $(modal).find("span.price").text(Shopify.formatMoney(data.price,"").replace(" ", ""));
            
            Shopify.getCart($.proxy(this.updateCountAndModal, this));
            //btn.notify("Successfully added to basket!", {autoHideDelay:2000,className:"success",showDuration:200,gap:2,elementPosition:"right middle"});
          }
            
  	},
    
    updateCountAndModal: function(data) {
      var modal = $(".add-basket").data("rel");
      $(modal).find("span.total_price").text(Shopify.formatMoney(data.total_price,"").replace(" ", ""));
      $(modal).find("span.item_count").text(data.item_count);

    	$(".add-basket").trigger("modal");
      
      this.updateCheckout(data);

      $(modal).find("a.continue").click(function(e) {
        e.preventDefault();
        
        $("#lean_overlay").fadeOut(200).remove();
        $(modal).css({
          "display": "none"
        });
      });
      
    },
  	
  	updateCount : function(data)  {
      this.updateCheckout(data);
  		$("li.cart_holder a.cart span.cart_count").text(data.item_count);
  	},

    updateCheckout: function(data) {
      if(data.total_price < LF.mo) {
        $('a.checkout').prop('href', '/cart');
      } else {
        $('a.checkout').prop('href', '/checkout');
      }
    }
  }
})($, LF);

